import React, { useContext, useMemo, useState } from "react";
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { DarkModeContext } from "../../context/DarkModeContext";
import "./ContenidoOperacionesAliado.css";
import { getToken } from "../../utils/auth";


const apiBuscar = process.env.REACT_APP_API_ALIADOOPS_BUSCAR_CUPONES;

const formatoMoneda = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const filtrosIniciales = {
  fechaOperacion: "",
  nroCupon: "",
  ultimos4Tarjeta: "",
  tarjeta: "",
  cuotas: "",
  totalBruto: "",
};

const BuscadorCuponesAliado = () => {
  const { darkMode } = useContext(DarkModeContext);
  const [filtros, setFiltros] = useState(filtrosIniciales);
  const [resultados, setResultados] = useState([]);
  const [cargandoBusqueda, setCargandoBusqueda] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  const hayFiltros = useMemo(
    () => Object.values(filtros).some((value) => String(value || "").trim() !== ""),
    [filtros]
  );

  const resumen = useMemo(() => {
    const totalBruto = resultados.reduce((acc, item) => acc + (Number(item.totalBruto) || 0), 0);
    const conCobroProgramado = resultados.filter((item) => item.fechaCobroProgramada).length;

    return {
      cantidad: resultados.length,
      totalBruto,
      conCobroProgramado,
      operacionesEstandar: Math.max(resultados.length - conCobroProgramado, 0),
    };
  }, [resultados]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusquedaRealizada(true);

    if (!hayFiltros) {
      setResultados([]);
      return;
    }

    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Sesion invalida",
        text: "Volve a iniciar sesion.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setCargandoBusqueda(true);
    try {
      const response = await fetch(apiBuscar, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          fechaOperacion: formatearFechaParaApi(filtros.fechaOperacion),
          nroCupon: filtros.nroCupon,
          ultimos4Tarjeta: filtros.ultimos4Tarjeta,
          tarjeta: filtros.tarjeta,
          cuotas: filtros.cuotas,
          totalBruto: filtros.totalBruto,
        }),
      });

      if (!response.ok) {
        throw new Error("No se pudo ejecutar la busqueda");
      }

      const data = await response.json();
      setResultados(Array.isArray(data) ? data : []);
    } catch (error) {
      Swal.fire({
        title: "No pudimos buscar cupones",
        text: "Proba de nuevo con otros filtros.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setCargandoBusqueda(false);
    }
  };

  return (
    <div className="operaciones-aliado-wrap operaciones-aliado-coupon-search">
      <div className={darkMode ? "operaciones-aliado-card operaciones-aliado-card-dark" : "operaciones-aliado-card"}>
        <form className="operaciones-aliado-form-panel" onSubmit={handleSubmit}>
          <div className="operaciones-aliado-form-grid">
            <div className="operaciones-aliado-field operaciones-aliado-field-amount">
              <label className="operaciones-aliado-label">Monto bruto</label>
              <input type="text" className="operaciones-aliado-input" name="totalBruto" value={filtros.totalBruto} onChange={handleChange} placeholder="$" autoComplete="off" />
            </div>
            <div className="operaciones-aliado-field">
              <label className="operaciones-aliado-label">Fecha</label>
              <input type="date" className="operaciones-aliado-input" name="fechaOperacion" value={filtros.fechaOperacion} onChange={handleChange} />
            </div>
            <div className="operaciones-aliado-field">
              <label className="operaciones-aliado-label">Tarjeta</label>
              <input type="text" className="operaciones-aliado-input" name="tarjeta" value={filtros.tarjeta} onChange={handleChange} placeholder="Ej: VISA" autoComplete="off" />
            </div>
            <div className="operaciones-aliado-field">
              <label className="operaciones-aliado-label">N.º de cupon</label>
              <input type="text" className="operaciones-aliado-input" name="nroCupon" value={filtros.nroCupon} onChange={handleChange} placeholder="Ej: 123456" autoComplete="off" />
            </div>
            <div className="operaciones-aliado-field">
              <label className="operaciones-aliado-label">Ult. 4</label>
              <input type="text" className="operaciones-aliado-input" name="ultimos4Tarjeta" value={filtros.ultimos4Tarjeta} onChange={handleChange} maxLength="4" placeholder="Ej: 1234" autoComplete="off" />
            </div>
            <div className="operaciones-aliado-field">
              <label className="operaciones-aliado-label">Cuotas</label>
              <input type="text" className="operaciones-aliado-input" name="cuotas" value={filtros.cuotas} onChange={handleChange} placeholder="Ej: 3" autoComplete="off" />
            </div>
          </div>

          <div className="operaciones-aliado-actions">
            <button type="submit" className="operaciones-aliado-btn operaciones-aliado-btn-primary" disabled={cargandoBusqueda}>
              {!cargandoBusqueda && <FontAwesomeIcon icon={faMagnifyingGlass} />}
              {cargandoBusqueda ? "Filtrando..." : "Filtrar"}
            </button>
          </div>
        </form>

        {busquedaRealizada && !cargandoBusqueda && (
          <div className="operaciones-aliado-kpi-grid">
            <div className="operaciones-aliado-kpi-card">
              <span className="operaciones-aliado-kpi-label">Operaciones</span>
              <strong className="operaciones-aliado-kpi-value">{resumen.cantidad}</strong>
              <span className="operaciones-aliado-kpi-foot">Resultados de esta busqueda</span>
            </div>
            <div className="operaciones-aliado-kpi-card">
              <span className="operaciones-aliado-kpi-label">Bruto acumulado</span>
              <strong className="operaciones-aliado-kpi-value">{formatearMoneda(resumen.totalBruto)}</strong>
              <span className="operaciones-aliado-kpi-foot">Suma de los registros mostrados</span>
            </div>
            <div className="operaciones-aliado-kpi-card">
              <span className="operaciones-aliado-kpi-label">Con fecha de cobro</span>
              <strong className="operaciones-aliado-kpi-value">{resumen.conCobroProgramado}</strong>
              <span className="operaciones-aliado-kpi-foot">Operaciones con cobro programado</span>
            </div>
            <div className="operaciones-aliado-kpi-card">
              <span className="operaciones-aliado-kpi-label">Estandar</span>
              <strong className="operaciones-aliado-kpi-value">{resumen.operacionesEstandar}</strong>
              <span className="operaciones-aliado-kpi-foot">Sin fecha de cobro adicional</span>
            </div>
          </div>
        )}

        <div className="operaciones-aliado-table-shell">
          {cargandoBusqueda ? (
            <div className="operaciones-aliado-loading-inline">
              <ThreeDots visible height="46" width="46" color="#b4c400" />
            </div>
          ) : !busquedaRealizada ? (
            <EstadoVacio
              titulo="Todavia no hay resultados"
              texto="Completa uno o mas filtros y presiona Buscar para consultar tus operaciones."
            />
          ) : resultados.length === 0 ? (
            <EstadoVacio
              titulo="No encontramos operaciones"
              texto="Ajusta los filtros o combina otros criterios para volver a intentar."
            />
          ) : (
            <>
              <div className="operaciones-aliado-table-toolbar">
                <span className="operaciones-aliado-table-note">
                  Resultados | {resumen.cantidad} operacion{resumen.cantidad === 1 ? "" : "es"}
                </span>
                {resumen.cantidad >= 250 && (
                  <span className="operaciones-aliado-inline-note">Se aplico el limite de 250 operaciones por consulta.</span>
                )}
              </div>
              <div className="table-responsive operaciones-aliado-table-responsive">
                <Table className="operaciones-aliado-table" responsive hover>
                  <thead>
                    <tr className={darkMode ? "operaciones-aliado-head-row operations-aliado-head-row-dark" : "operaciones-aliado-head-row"}>
                      <th>Fecha op.</th>
                      <th>Cupon</th>
                      <th>Tarjeta</th>
                      <th>Comercio</th>
                      <th>Bruto</th>
                      <th>Neto</th>
                      <th>Fecha cobro</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((item, index) => (
                      <tr key={`${item.nroCupon || "cupon"}-${index}`}>
                        <td>{formatearFecha(item.fechaOperacion)}</td>
                        <td>{item.nroCupon || "-"}</td>
                        <td>
                          <div className="operaciones-aliado-cell-title">{item.tarjeta || "-"}</div>
                          <span className="operaciones-aliado-cell-subtitle">**** {item.ultimos4Tarjeta || "-"}</span>
                        </td>
                        <td>
                          <div className="operaciones-aliado-cell-title">{item.comercio || "-"}</div>
                          <span className="operaciones-aliado-cell-subtitle">Comercio {item.nroComercio || "-"}</span>
                        </td>
                        <td>{formatearMoneda(item.totalBruto)}</td>
                        <td>{formatearMoneda(item.totalNeto)}</td>
                        <td>{item.fechaCobroProgramada ? formatearFecha(item.fechaCobroProgramada) : "-"}</td>
                        <td>
                          <span className={`operaciones-aliado-status ${item.estadoCobroProgramado ? "operaciones-aliado-status-programado" : ""}`}>
                            {item.estadoCobroProgramado || "Operacion estandar"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const EstadoVacio = ({ titulo, texto }) => (
  <div className="operaciones-aliado-empty-box">
    <div className="operaciones-aliado-empty-icon">i</div>
    <strong className="operaciones-aliado-empty-title">{titulo}</strong>
    <span className="operaciones-aliado-empty-copy">{texto}</span>
  </div>
);

const formatearFecha = (value) => {
  if (!value) return "-";
  const fecha = new Date(value);
  if (Number.isNaN(fecha.getTime())) return "-";
  return fecha.toLocaleDateString("es-AR");
};

const formatearFechaParaApi = (value) => {
  if (!value) return "";
  const [anio, mes, dia] = value.split("-");
  if (!anio || !mes || !dia) return "";
  return `${dia}/${mes}/${anio}`;
};

const formatearMoneda = (value) => {
  if (value == null || value === "") return "-";
  return formatoMoneda.format(Number(value) || 0);
};

export default BuscadorCuponesAliado;
